import { Controller } from "@hotwired/stimulus"
import jQuery from "jquery"
import "select2"

// Ensure jQuery is available globally for Select2
window.$ = window.jQuery = jQuery

export default class extends Controller {
  static values = {
    width: { type: String, default: '100%' }
  }

  connect() {
    this.initializeSelect2()
  }

  disconnect() {
    $(this.element).select2('destroy')
  }

  initializeSelect2() {
    $(this.element).select2({
      theme: 'bootstrap-5',
      width: this.widthValue,
      placeholder: $(this.element).data('placeholder'),
      allowClear: true,
      selectionCssClass: 'select2--small',
      dropdownCssClass: 'select2--small'
    })
  }
}
